import { useState } from 'react';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import {
  signupEmail,
  handleGoogleSignup,
  google_sign_client_id,
} from '../../../apiservices/axiosservice/authentication';
import { useNavigate } from 'react-router-dom';
import './styles/SignupScreen.css';

const SignupScreen: React.FC = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleSignUp = async () => {
    if (!firstName) { setErrorMessage('First name is required.'); return; }
    if (!lastName) { setErrorMessage('Last name is required.'); return; }
    if (!email) { setErrorMessage('Email is required.'); return; }
    if (!password) { setErrorMessage('Password is required.'); return; }

    const requestData = { email, password, firstName, lastName };
    try {
      setIsLoading(true);
      const response = await signupEmail(requestData);
      setErrorMessage('');
      setIsLoading(false);
      if (response.data) handleUserNavigation(response.data);
    } catch (error: any) {
      setIsLoading(false);
      setErrorMessage(error.message);
    }
  };

  const handleSignUpSuccess = async (response) => {
    try {
      setIsLoading(true);
      const serverResponse = await handleGoogleSignup({ token: response.credential });
      if (serverResponse.data) handleUserNavigation(serverResponse.data);
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
      setErrorMessage(error.message);
    }
  };

  const handleUserNavigation = (data: any) => {
    const { loginMode, verified, profiled } = data.user;
    if (loginMode === 'custom') {
      if (!verified) navigate('/signup-confirmation', { state: { loginMode } });
      else if (verified && profiled) navigate('/dashboard/home');
      else if (verified && !profiled) navigate('/profile-subscriber');
    }
    if (loginMode === 'google') {
      navigate('/signup-confirmation', { state: { loginMode } });
    }
  };

  return (
    <div className="signup-page">
      {/* Left sidebar - desktop only */}
      <aside className="signup-sidebar">
        <button className="back-btn" onClick={() => navigate('/')}>← Back</button>
        <div className="sidebar-brand">
          <img src="/funhives.png" alt="FunHives" className="sidebar-logo" />
          <p className="sidebar-tagline">JOIN MILLIONS OF QUIZ CREATORS</p>
        </div>
        <nav className="sidebar-nav">
          <button className="nav-item nav-quiz" onClick={() => navigate('/join')}>
            <span className="nav-icon">⭐</span> Smart Quiz
          </button>
          <button className="nav-item nav-geo" onClick={() => navigate('/join')}>
            <span className="nav-icon">⊙</span> Geo Guess
          </button>
          <button className="nav-item nav-custom" disabled>
            <span className="nav-icon">✏️</span> Custom Quiz
          </button>
          <button className="nav-item nav-drawing" disabled>
            <span className="nav-icon">⚙️</span> Drawing
          </button>
        </nav>
      </aside>

      {/* Right content - form */}
      <main className="signup-main">
        <div className="signup-form-wrapper">
          <div className="signup-avatar">😊</div>
          <h1 className="signup-title">Create Your Account</h1>
          <p className="signup-subtitle">Start building quizzes in seconds</p>

          <div className="signup-form">
            <input
              type="text"
              placeholder="First Name"
              className="signup-input"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
            <input
              type="text"
              placeholder="Last Name"
              className="signup-input"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
            <input
              type="email"
              placeholder="Email Address"
              className="signup-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="password"
              placeholder="Password"
              className="signup-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            {errorMessage && (
              <div className="signup-error">
                <span>⚠</span> {errorMessage}
              </div>
            )}

            <p className="signup-terms">
              By signing up you agree to our <a href="/privacy">Terms & Privacy Policy</a>
            </p>

            <button
              className="signup-submit-btn"
              onClick={handleSignUp}
              disabled={isLoading}
            >
              {isLoading ? 'Creating...' : 'Create Account'}
            </button>

            <div className="signup-divider"><span>or</span></div>

            <GoogleOAuthProvider clientId={google_sign_client_id}>
              <div className="signup-google">
                <GoogleLogin
                  onSuccess={handleSignUpSuccess}
                  onError={() => setErrorMessage('Google sign up failed')}
                  text="signup_with"
                  width="100%"
                />
              </div>
            </GoogleOAuthProvider>
          </div>

          <p className="signup-login-link">
            Already have an account? <a href="/login">Sign In</a>
          </p>
        </div>
      </main>
    </div>
  );
};

export default SignupScreen;
